module.exports = __webpack_public_path__ + "img/2010_L.426188c8.png";